import { useCallback, useContext } from 'react';
import AuthContext from '../context/authContext';
import useHttp from './useHttp';

const useAgentCallbacks = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getCallbacks = useCallback(
    async ({ status, query, limit = 200 } = {}) => {
      const params = new URLSearchParams();
      if (status) params.set('status', status);
      if (query) params.set('q', query);
      params.set('limit', String(limit));

      return sendRequest({
        url: `/api/v1/agentCallback?${params.toString()}`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
    },
    [authCtx, sendRequest]
  );

  const getCallbackCounts = useCallback(
    async () =>
      sendRequest({
        url: '/api/v1/agentCallback/counts',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      }),
    [authCtx, sendRequest]
  );

  const updateCallback = useCallback(
    async (callbackId, payload) =>
      sendRequest({
        url: `/api/v1/agentCallback/${callbackId}`,
        method: 'PATCH',
        headers: authCtx.getAuthHeaders(),
        body: payload,
      }),
    [authCtx, sendRequest]
  );

  return {
    isLoading,
    error,
    getCallbacks,
    getCallbackCounts,
    updateCallback,
  };
};

export default useAgentCallbacks;
